// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"c735b0c5","452":"7ffc86a6","580":"9fbac2d6","599":"c4ff340f"}[chunkId] + ".chunk.js";
};